export default "__VITE_ASSET__DEBw68T7__"